module.exports = "<img class=\"defined-width\" [src]=\"imageUrl\" (error)=\"onError($event)\" />\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/images/image.component.html
// module id = ./src/app/shared/components/images/image.component.html
// module chunks = main